/**
 * AUTO-GENERATED — DO NOT EDIT.
 * Source: sdk.manifest.yml + openapi.json.
 * Regenerate with: pnpm gen
 */

import { createMutationHook } from '../../core/factories/createMutation.js';
import type { AdvanceAdminMarketCreationResponse, AdvanceAdminMarketCreationVars } from '../openapi-types.gen.js';

export type { AdvanceAdminMarketCreationResponse, AdvanceAdminMarketCreationVars } from '../openapi-types.gen.js';

export const useAdvanceAdminMarketCreation = createMutationHook<AdvanceAdminMarketCreationVars, AdvanceAdminMarketCreationResponse, unknown>({
  specName: 'useAdvanceAdminMarketCreation',
  path: '/v1/admin/market-creations/{id}/advance',
  method: 'POST',
  resolveUrl: (vars: AdvanceAdminMarketCreationVars) => `/v1/admin/market-creations/${vars.id}/advance`,
  buildBody: (vars: AdvanceAdminMarketCreationVars) => ({ proof: vars.proof, creatorProof: vars.creatorProof, signedTransactionBase64: vars.signedTransactionBase64 }),
  parseResponse: (raw: unknown): AdvanceAdminMarketCreationResponse => raw as AdvanceAdminMarketCreationResponse,
  
  
  
});
